import { gql, useMutation } from '@apollo/client'

export const UPDATE_PROJECT = gql`
  mutation ($input: CampaignUpdate) {
    updateCampaign(input: $input) {
      id
      name
      active
      artist_id
      created_at
      info
      unit_id
      team_info
      isaac_url {
        title
        url
      }
      main_product_id
      owner_id
      project_id
      __typename
    }
  }
`

export const useUpdateProject = () => {
  const [mutate, { data, loading, error }] = useMutation(UPDATE_PROJECT, {
    update(cache) {
      cache.modify({
        fields: {
          getCampaign() {},
          getArtists() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
